export default __webpack_public_path__ + "static/media/Banner2022_African-min.d9b8f66b.png";